<div class="error-area ptb-100">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="error-content">
                    <img src="assets/img/error.png" alt="image">
                    <h3>Error 404 : Page Non trouvée</h3>
                    <p>La page que vous recherchez a peut-être été supprimée, son nom a changé ou est temporairement indisponible.</p>
                    <div class="btn-box">
                        <a routerLink="/" class="default-btn"><i class="flaticon-home"></i>Accueil<span></span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>